// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SortAscendingComponent} from './SortAscending.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSortAscending = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SortAscendingComponent/>
  </Icon>
));
